<template>
  <div class="test" ref="test">
    <div
      ref="modal12"
      :style="{ width: imgW + 200 + 'px' }"
      class="md-modal md-effect-12"
      id="modal-12"
    >
      <div class="md-content">
        <img v-if="showDetailType <= 1" src="" :style="{ width: imgW + 'px' }" />
        <video
          controls="controls"
          autoplay
          v-else-if="showDetailType > 1"
          src=""
          :style="{ width: imgW + 'px' }"
        />
      </div>
    </div>
    <div>
      <div ref="infoDetail" class="infoDetail">
        <warn1-tiny
          class="warn1-Tiny"
          :detailData="detailData"
          :typeId="detailID"
        ></warn1-tiny>
      </div>
      <div ref="infoHistory" class="infoHistory">
        <div class="warn1_title">
          <div
            class="popup-type1-title"
            :class="{ 'popup-type1-title_green': treatType }"
          >
            {{ detailData.typeName }}-{{
              detailData.metric +
              (detailData.warnType === 1
                ? "超标"
                : detailData.warnType === 2
                ? "超低"
                : "")
            }}
          </div>
          <div class="popup-type1-time">
            {{ detailData.eventTime ? detailData.eventTime.slice(5, 16) : "" }}
          </div>
        </div>
        <div ref="chart" class="historyChart"></div>
      </div>
    </div>
    <div class="processComponent">
      <div class="everyComponent">
        <ul>
          <template v-for="(item, i) in cachePointList">
            <li
              v-show="false"
              :id="'playPos-' + i"
              v-if="
                winPos[i + cacheList.length] &&
                winPos[i + cacheList.length][0] &&
                winPos[i + cacheList.length][3] &&
                item['status'] == 'play'
              "
              :key="i"
              class="ComponentTip_"
              :style="{
                left: winPos[i + cacheList.length][0] / prew - 29 + 'px',
                bottom: winPos[i + cacheList.length][3] / prew - 32 + 'px',
              }"
            >
              <div v-if="!item.type">
                <img class="red" src="./img/red.png" />
              </div>
              <div v-else-if="item.type">
                <img class="green" src="./img/green.png" />
              </div>
            </li>
          </template>
        </ul>
        <ul>
          <template v-for="(item, i) in cacheList">
            <li
              :id="'playTip-' + i"
              v-if="winPos[i] && winPos[i][0] && winPos[i][3] && item['status'] == 'play'"
              :key="i"
              class="ComponentTip"
              :style="{
                left: winPos[i][0] / prew - 255 + 'px',
                bottom: winPos[i][3] / prew - 160 + 'px',
              }"
            >
              <div
                class="warn_block"
                v-if="item.typeId !== '000' && item.typeId !== '同步率'"
              >
                <div
                  class="warn_innerBlock"
                  @click="openDiv()"
                  @mousemove="stopWarning(i)"
                  @mouseenter="stopWarning(i)"
                  @mouseleave="restoreWarning(i)"
                >
                  <warn1 class="warn1" :data="item.data" :typeId="item.typeId"></warn1>
                </div>
                <img class="img2" src="./img/4.png" alt="" />
              </div>
              <div class="warn_block" v-else-if="item.typeId == '000'">
                <div
                  class="warn_innerBlock"
                  @click="openDiv()"
                  @mousemove="stopWarning(i)"
                  @mouseenter="stopWarning(i)"
                  @mouseleave="restoreWarning(i)"
                >
                  <warn2 class="warn2" :data="item.data"></warn2>
                </div>
                <img class="img2" src="./img/4.png" alt="" />
              </div>
              <div class="warn_block" v-else-if="item.typeId == '同步率'">
                <div
                  class="warn_innerBlock"
                  @click="openDiv()"
                  @mousemove="stopWarning(i)"
                  @mouseenter="stopWarning(i)"
                  @mouseleave="restoreWarning(i)"
                >
                  <warn3 class="warn3" :data="item.data"></warn3>
                </div>
                <img class="img2" src="./img/4.png" alt="" />
              </div>
            </li>
          </template>
        </ul>
        <ul>
          <li :id="'dustTip-0'" class="DustTip" v-if="true" :style="getDustCurStyle()">
            <div class="trace_source" ref="traceSource">
              <img src="./img/dust.png" class="dustRotate" />
            </div>
          </li>
          <li :id="'dustTip-1'" v-if="true"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState, mapGetters } from "vuex";
import Warn1 from "./warn1.vue";
import Warn2 from "./warn2.vue";
import Warn3 from "./warn3.vue";
import Warn1Tiny from "./warn1_tiny.vue";

import getOpt from "./js/chartOpt.js";
import { unwarp } from "@/utils/tools.js";

import { unref } from "vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { Warn1, Warn2, Warn3, Warn1Tiny },
  inject: ["getEventData"],
  data() {
    //这里存放数据
    return {
      imgH: bmeConfig.INIT_HEIGHT * 0.6,
      imgW: bmeConfig.INIT_WIDTH * 0.5,
      showDetailType: 0,
      customerId: this.$store.state.customerId,
      fadeInTimer: {},
      fadeOutTimer: {},

      cacheList: [
        {
          tipID: "playTip-0",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
        {
          tipID: "playTip-1",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
        {
          tipID: "playTip-2",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
        {
          tipID: "playTip-3",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
      ],
      cachePointList: [
        {
          tipID: "playPos-0",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-1",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-2",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-3",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-4",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-5",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-0",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-6",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-7",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-8",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-9",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
      ],
      playList: [],
      pointList: [],
      winPos: [], //排放源点的定位
      isStop: false,
      //stopTime: 0,
      stopIndex: "",
      countIndex: 0,
      detailData: {},
      detailID: "",
      otherTimer: "",
      valueHistory: [],
      needDetail: false,
      counter: 0,
      treatType: false,

      singlePlayTimer: "",
      restoreWarnTimer: "",
      //dutyTimer: [],
      //dutyPointTimer: [],

      lastRenderPlayTime: "",
      preventStopTimer: "",
      getDataTimer: "",

      traceSource: true,
      dustRate: 1,
      dustTimer: null,
      dutyStore: [],
    };
  },
  //计算属性 类似于data概念
  computed: {
    ...mapState({ prew: "scaleValue" }),

    getDustCurStyle() {
      return function (n) {
        if (
          this.winPos[this.cacheList.length + this.cachePointList.length + 1] &&
          this.winPos[this.cacheList.length + this.cachePointList.length + 1][0] &&
          this.winPos[this.cacheList.length + this.cachePointList.length + 1][3]
        ) {
          let l =
            this.winPos[this.cacheList.length + this.cachePointList.length + 1][0] /
              this.prew -
            25;
          let b =
            this.winPos[this.cacheList.length + this.cachePointList.length + 1][3] /
              this.prew -
            25;
          return {
            left: l + "px",
            bottom: b + "px",
            position: "absolute",
          };
        } else {
          return {
            left: "0px",
            bottom: "0px",
            position: "absolute",
          };
        }
      };
    },
  },
  //监控data中的数据变化
  watch: {
    getEventData: {
      handler(newVal, oldVal) {
        let that = this;
        let tmpObj = unref(newVal);
        let workTicketNo = tmpObj["workTicketNo"];
        if (this.singlePlayTimer) {
          clearTimeout(this.singlePlayTimer);
        }
        this.singlePlayTimer = setTimeout(function () {
          that.getSinglePlayEvent(workTicketNo);
        }, 150);
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    this.dataReset();

    this.altitude =
      bmeConfig.altitude || bmeConfig.altitude === 0 ? bmeConfig.altitude : 50;
    this.flyAltitude = this.altitude < 350 ? 350 : this.altitude;

    //this.tipList();
    let total = this.cacheList.length + this.cachePointList.length + 2;
    for (let i = 0; i < total; i++) {
      this.winPos.push([]);
    }
    for (let i = 0; i < this.cacheList.length; i++) {
      this.$dutyTimer.push({});
    }
    for (let i = 0; i < this.cachePointList.length; i++) {
      this.$dutyPointTimer.push({});
    }
    for (let i = 0; i < this.$dutyTimer.length; i++) {
      for (let j in this.$dutyTimer[i]) {
        if (this.$dutyTimer[i][j]) {
          clearTimeout(this.$dutyTimer[i][j]);
        }
      }
    }

    for (let i = 0; i < this.$dutyPointTimer.length; i++) {
      for (let j in this.$dutyPointTimer[i]) {
        if (this.$dutyPointTimer[i][j]) {
          clearTimeout(this.$dutyPointTimer[i][j]);
        }
      }
    }
    this.flyToFixedPoint(function () {
      //that.getData();
      that.renderPlay();
      that.preventStop();
    });
    $(this.$refs.test).unbind("click");
    $(this.$refs.test).bind("click", function () {
      that.closeDiv();
    });
  },
  activated() {
    let that = this;
    this.dataReset();
    let total = this.cacheList.length + this.cachePointList.length + 2;
    for (let i = 0; i < total; i++) {
      this.winPos.push([]);
    }
    for (let i = 0; i < this.cacheList.length; i++) {
      this.$dutyTimer.push({});
    }
    for (let i = 0; i < this.cachePointList.length; i++) {
      this.$dutyPointTimer.push({});
    }
    for (let i = 0; i < this.$dutyTimer.length; i++) {
      for (let j in this.$dutyTimer[i]) {
        if (this.$dutyTimer[i][j]) {
          clearTimeout(this.$dutyTimer[i][j]);
        }
      }
    }

    for (let i = 0; i < this.$dutyPointTimer.length; i++) {
      for (let j in this.$dutyPointTimer[i]) {
        if (this.$dutyPointTimer[i][j]) {
          clearTimeout(this.$dutyPointTimer[i][j]);
        }
      }
    }
    this.flyToFixedPoint(function () {
      //that.getData();
      that.renderPlay();
      that.preventStop();
    });

    $(this.$refs.test).unbind("click");
    $(this.$refs.test).bind("click", function () {
      that.closeDiv();
    });
  }, //如果页面有keep-alive缓存功能，这个函数会触发
  deactivated() {
    /*clearTimeout(this.renderTimer);
    clearTimeout(this.getDataTimer);
    clearTimeout(this.flyToFixedTimer);*/

    for (let i = 0; i < this.$dutyTimer.length; i++) {
      for (let j in this.$dutyTimer[i]) {
        if (this.$dutyTimer[i][j]) {
          clearTimeout(this.$dutyTimer[i][j]);
        }
      }
    }

    for (let i = 0; i < this.$dutyPointTimer.length; i++) {
      for (let j in this.$dutyPointTimer[i]) {
        if (this.$dutyPointTimer[i][j]) {
          clearTimeout(this.$dutyPointTimer[i][j]);
        }
      }
    }

    this.dataReset();
    /*for (var i in this.fadeInTimer) {
      if (this.fadeInTimer[i]) {
        clearTimeout(this.fadeInTimer[i]);
      }
    }

    for (var i in this.fadeOutTimer) {
      if (this.fadeOutTimer[i]) {
        clearTimeout(this.fadeOutTimer[i]);
      }
    }*/
  },
  beforeUnmount() {
    /*clearTimeout(this.renderTimer);
    clearTimeout(this.getDataTimer);
    clearTimeout(this.flyToFixedTimer);*/

    for (let i = 0; i < this.$dutyTimer.length; i++) {
      for (let j in this.$dutyTimer[i]) {
        if (this.$dutyTimer[i][j]) {
          clearTimeout(this.$dutyTimer[i][j]);
        }
      }
    }

    for (let i = 0; i < this.$dutyPointTimer.length; i++) {
      for (let j in this.$dutyPointTimer[i]) {
        if (this.$dutyPointTimer[i][j]) {
          clearTimeout(this.$dutyPointTimer[i][j]);
        }
      }
    }

    this.dataReset();
    /*for (var i in this.fadeInTimer) {
      if (this.fadeInTimer[i]) {
        clearTimeout(this.fadeInTimer[i]);
      }
    }

    for (var i in this.fadeOutTimer) {
      if (this.fadeOutTimer[i]) {
        clearTimeout(this.fadeOutTimer[i]);
      }
    }*/
  },
  //方法集合
  methods: {
    preventStop() {
      let that = this;
      let nowTime = new Date().getTime();
      if (this.lastRenderPlayTime) {
        if (nowTime - this.lastRenderPlayTime > 60 * 1000) {
          this.stopIndex = -1;
          this.$isStop.status = false;
          this.renderPlay();
        }
      }
      if (this.preventStopTimer) {
        clearTimeout(this.preventStopTimer);
      }
      this.preventStopTimer = setTimeout(function () {
        that.preventStop();
      }, 1000);
    },
    dataReset() {
      this.cacheList = [
        {
          tipID: "playTip-0",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
        {
          tipID: "playTip-1",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
        {
          tipID: "playTip-2",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
        {
          tipID: "playTip-3",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
      ];
      this.cachePointList = [
        {
          tipID: "playPos-0",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-1",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-2",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-3",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-4",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-5",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-0",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-6",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-7",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-8",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-9",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
      ];
      this.playList = [];
      this.pointList = [];
      this.winPos = []; //排放源点的定位
      this.$isStop.status = false;
      this.stopTime = 0;
      this.stopIndex = -1;
      this.countIndex = 0;
    },
    //初始飞行
    flyToFixedPoint(cb) {
      if (bmeConfig.mapType !== "3D") {
        if (cb) {
          cb();
        }
        return;
      }
      let that = this;
      if (that.flyToFixedTimer) {
        clearTimeout(this.flyToFixedTimer);
      }
      if (
        window.g_bme3dManager &&
        window.g_bme3dManager.earth &&
        window.g_bme3dManager.earth.camera
      ) {
        let view =
          mapViews[`mapViews_${that.customerId}`] &&
          mapViews[`mapViews_${that.customerId}`].dutyMod;
        if (view && view.length) {
          //debugger;
          window.g_bme3dManager.earth.camera.flyTo(view[0], view[1], view[2], view[3]);

          if (that.flyToFixedTimer) {
            clearTimeout(this.flyToFixedTimer);
          }
          that.flyToFixedTimer = setTimeout(function () {
            if (cb) {
              cb();
            }
          }, 4000);
        } else {
          if (that.flyToFixedTimer) {
            clearTimeout(this.flyToFixedTimer);
          }
          that.flyToFixedTimer = setTimeout(function () {
            if (cb) {
              cb();
            }
          }, 4000);
        }
      } else {
        that.flyToFixedTimer = setTimeout(function () {
          that.flyToFixedPoint(cb);
        }, 500);
      }
    },
    openDiv() {
      let that = this;
      let randomNum = Math.ceil(Math.random() * 2);
      this.showDetailType = randomNum;
      setTimeout(function () {
        $(that.$refs.modal12).fadeIn(1000, function () {
          $(that.$refs.test).addClass("pointerEventAll");
        });
      }, 500);
    },
    closeDiv() {
      let that = this;
      $(this.$refs.modal12).fadeOut(500, function () {
        $(that.$refs.test).removeClass("pointerEventAll");
      });
    },
    stopWarning(n) {
      this.$isStop.status = true;
      this.stopTime = new Date().getTime();
      this.stopIndex = n;

      this.timeoutClear();
    },
    restoreWarning(n) {
      let that = this;
      if (this.restoreWarnTimer) {
        clearTimeout(this.restoreWarnTimer);
      }
      this.restoreWarnTimer = setTimeout(function () {
        that.$isStop.status = false;
        that.timeoutClear();
        that.renderPlay();
      }, 1000);
    },
    timeoutClear() {
      if (this.restoreWarnTimer) {
        clearTimeout(this.restoreWarnTimer);
      }
      if (this.dustTimer) {
        clearTimeout(this.dustTimer);
      }
      if ($(".dustRotate").length > 0 && $(".dustRotate").stop) {
        $(".dustRotate").stop(true, true);
        $(".DustTip").hide();
        $(".dustRotate").hide();
      }
      for (let i = 0; i < this.$dutyTimer.length; i++) {
        for (let j in this.$dutyTimer[i]) {
          if (this.$dutyTimer[i][j]) {
            clearTimeout(this.$dutyTimer[i][j]);
          }
        }
      }
      for (let i = 0; i < this.$dutyPointTimer.length; i++) {
        for (let j in this.$dutyPointTimer[i]) {
          if (this.$dutyPointTimer[i][j]) {
            clearTimeout(this.$dutyPointTimer[i][j]);
          }
        }
      }
      this.cacheList.forEach((item) => {
        item.status = "wait";
      });
    },
    //点击详情
    async getSinglePlayEvent(workTicketNo) {
      let that = this;
      this.$isStop.status = true;
      this.timeoutClear();
      let unionDetailUrl = CONFIG.requestName + this.$apiOpt.unionDetail;
      let data = await this.$apiUtils.get(unionDetailUrl, {
        workTicketNo: workTicketNo,
      });
      [data].forEach((_, i) => {
        let devicePos = {};
        _.isHistory = true;

        that.getDevicePos(_.deviceNo).then((res) => {
          devicePos = res;
          let obj = {
            type: _.handleState == 2 || _.handleState == 3 ? 1 : 0,
            lng: devicePos.longitude || 0,
            lat: devicePos.latitude || 0,
            height: bmeConfig.altitude,
            data: _,
            typeId: _.typeId,
            isHistory: true,
          };

          this.getFindSpread(_.deviceNo)
            .then((res) => {
              let spreadObj = res;
              if (
                spreadObj &&
                spreadObj.length > 0 &&
                Object.prototype.toString.call(spreadObj[0]) === "[object Object]" &&
                spreadObj[0]["longitude"] &&
                spreadObj[0]["latitude"] &&
                spreadObj[0]["predict_lon"] &&
                spreadObj[0]["predict_lat"]
              ) {
                obj.spreadLng = spreadObj[0]["longitude"];
                obj.spreadLat = spreadObj[0]["latitude"];
                obj.spreadPredictLng = spreadObj[0]["predict_lon"];
                obj.spreadPredictLat = spreadObj[0]["predict_lat"];
              } else {
                obj.spreadLng = obj["lng"];
                obj.spreadLat = obj["lat"];
                obj.spreadPredictLng = obj["lng"] + 0.05 * (Math.random() - 1) * 2;
                obj.spreadPredictLat = obj["lat"] + 0.05 * (Math.random() - 1) * 2;
              }
              that.playList.unshift(obj);

              that.timeoutClear();
              that.$isStop.status = false;
              that.stopIndex = -1;

              for (let j in that.cacheList) {
                if (that.cacheList[j]["status"] == "play") {
                  $("#" + that.cacheList[j]["tipID"]).fadeOut(50, function () {
                    that.cacheList[j]["status"] = "wait";
                  });
                }
              }
              that.stopIndex = -1;
              that.renderPlay(true);
            })
            .catch((err) => {
              that.playList.unshift(obj);

              that.timeoutClear();
              that.$isStop.status = false;
              that.stopIndex = -1;

              for (let j in that.cacheList) {
                if (that.cacheList[j]["status"] == "play") {
                  $("#" + that.cacheList[j]["tipID"]).fadeOut(50, function () {
                    that.cacheList[j]["status"] = "wait";
                  });
                }
              }

              that.stopIndex = -1;
              that.renderPlay(true);
            });

          //that.flyToFixedPoint();
        });
      });
    },
    checkStore(list) {
      list.forEach((item) => {
        if (
          $.inArray(item.workTicketNo, this.dutyStore) <
          0 /*&&
          (item.handleState === 0 || item.handleState === 1)*/
        ) {
          this.dutyStore.push(item.workTicketNo);
        } else if (
          $.inArray(item.workTicketNo, this.dutyStore) >=
          0 /*&&
          (item.handleState === 2 || item.handleState === 3)*/
        ) {
          this.dutyStore.splice($.inArray(item.workTicketNo, this.dutyStore), 1);
        }
      });

      console.log(this.dutyStore);
      if (this.dutyStore.length > 0) {
        this.$message({
          type: "info",
          message: "这是一条消息提示",
          duration: 15000,
          showClose: true,
        });
      }
    },
    async getPlayEvents() {
      let scroll = CONFIG.requestName + this.$apiOpt.scroll;
      let data = await this.$apiUtils.get(scroll, {
        customerId: this.customerId,
      });
      if (data.length === 0) {
        this.getData();
      } else {
        //this.checkStore(data);
        data.forEach((_, i) => {
          let devicePos = {};
          this.getDevicePos(_.deviceNo).then((res) => {
            _.level = 0;
            devicePos = res;
            let obj = {
              type: _.handleState == 2 || _.handleState == 3 ? 1 : 0,
              lng: devicePos.longitude || 0,
              lat: devicePos.latitude || 0,
              height: bmeConfig.altitude,
              data: _,
              typeId: _.typeId,
            };
            this.getFindSpread(_.deviceNo)
              .then((res) => {
                let spreadObj = res;
                if (
                  spreadObj &&
                  spreadObj.length > 0 &&
                  Object.prototype.toString.call(spreadObj[0]) === "[object Object]" &&
                  spreadObj[0]["longitude"] &&
                  spreadObj[0]["latitude"] &&
                  spreadObj[0]["predict_lon"] &&
                  spreadObj[0]["predict_lat"]
                ) {
                  obj.spreadLng = spreadObj[0]["longitude"];
                  obj.spreadLat = spreadObj[0]["latitude"];
                  obj.spreadPredictLng = spreadObj[0]["predict_lon"];
                  obj.spreadPredictLat = spreadObj[0]["predict_lat"];
                } else {
                }
                this.playList.push(obj);
              })
              .catch((err) => {
                console.log(err);
                this.playList.push(obj);
              });
          });
        });
        this.renderPlay();
      }
    },
    getPointEvents() {
      let typeIndex = Math.floor(Math.random() * 2);
      let obj = {
        type: typeIndex,
        lng: 118.5526416 + Math.random() * 2 * 0.01,
        lat: 39.9679961 + Math.random() * 2 * 0.01,
        height: bmeConfig.altitude,
      };
      if (this.pointList.length > 10) {
        this.pointList.push(obj);
      }
    },

    //循环加数据
    getData() {
      let that = this;
      if (that.getDataTimer) {
        clearTimeout(that.getDataTimer);
      }
      that.getDataTimer = setTimeout(function () {
        that.getPlayEvents();
      }, 5000);
      // that.getPointEvents();
      /*if (this.getDataTimer) {
        clearTimeout(this.getDataTimer);
      }
      this.getDataTimer = setTimeout(function () {
        that.getData();
      }, 120000);*/
    },
    //画点
    drawPointTip(tipID, lng, lat, height, n, earth, warnType) {
      let that = this;
      let pin = earth.sceneTree.$refs[tipID];
      if (warnType === 0 || warnType === 1) {
        that.cachePointList[n]["type"] = 0;
      } else {
        that.cachePointList[n]["type"] = 1;
      }

      if (pin) {
        let pos = "[" + lng + "*Math.PI/180.0, " + lat + "*Math.PI/180.0," + height + "]";
        let pos1 = eval(pos);
        let pinCzm = pin.czmObject;
        pinCzm.position = pos1;
        let n_ = n + that.cacheList.length;
        XE.MVVM.track(this, "winPos." + n_, pinCzm, "winPos");
      } else {
        let pos = "[" + lng + "*Math.PI/180.0, " + lat + "*Math.PI/180.0," + height + "]";
        let pos1 = eval(pos);
        var tipListObj = {
          ref: tipID,
          czmObject: {
            name: tipID,
            xbsjType: "Pin",
            position: pos1,
            near: 300,
            show: false,
          },
        };
        earth.sceneTree.root.children.push(tipListObj);
        let pinCzm = earth.sceneTree.$refs[tipID].czmObject;
        let n_ = n + that.cacheList.length;
        XE.MVVM.track(this, "winPos." + n_, pinCzm, "winPos");
      }
      this.$forceUpdate();
    },
    //画弹窗
    getDustPos(earth, height, lng, lat, lng_, lat_, curRate) {
      let that = this;
      let frequency = 1000;
      curRate = curRate ? curRate : 1;
      let tipID = "dustTip-0";
      let pin = earth.sceneTree.$refs[tipID];
      let pinCzm;

      let tipID_ = "dustTip-1";
      let pin_ = earth.sceneTree.$refs[tipID_];
      let pinCzm_;
      if (pin) {
        let pos = "[" + lng + "*Math.PI/180.0, " + lat + "*Math.PI/180.0," + height + "]";
        let pos1 = eval(pos);
        pinCzm = pin.czmObject;
        pinCzm.position = pos1;
        XE.MVVM.track(
          that,
          "winPos." + (that.cacheList.length + that.cachePointList.length + 1),
          pinCzm,
          "winPos"
        );

        let pos_ =
          "[" + lng_ + "*Math.PI/180.0, " + lat_ + "*Math.PI/180.0," + height + "]";
        let pos1_ = eval(pos_);
        pinCzm_ = pin_.czmObject;
        pinCzm_.position = pos1_;
        XE.MVVM.track(
          that,
          "winPos." + (that.cacheList.length + that.cachePointList.length + 2),
          pinCzm_,
          "winPos"
        );
        //console.log("pinCzm", pinCzm);
      } else {
        let pos = "[" + lng + "*Math.PI/180.0, " + lat + "*Math.PI/180.0," + height + "]";
        let pos1 = eval(pos);
        var tipListObj = {
          ref: tipID,
          czmObject: {
            name: tipID,
            xbsjType: "Pin",
            position: pos1,
            near: 300,
            show: false,
          },
        };
        earth.sceneTree.root.children.push(tipListObj);
        pinCzm = earth.sceneTree.$refs[tipID].czmObject;
        XE.MVVM.track(
          that,
          "winPos." + (that.cacheList.length + that.cachePointList.length + 1),
          pinCzm,
          "winPos"
        );

        let pos_ =
          "[" + lng_ + "*Math.PI/180.0, " + lat_ + "*Math.PI/180.0," + height + "]";
        let pos1_ = eval(pos_);
        var tipListObj_ = {
          ref: tipID_,
          czmObject: {
            name: tipID_,
            xbsjType: "Pin",
            position: pos1_,
            near: 300,
            show: false,
          },
        };
        earth.sceneTree.root.children.push(tipListObj_);
        pinCzm_ = earth.sceneTree.$refs[tipID_].czmObject;
        XE.MVVM.track(
          that,
          "winPos." + (that.cacheList.length + that.cachePointList.length + 2),
          pinCzm_,
          "winPos"
        );
      }
      if ($(".DustTip").length > 0) {
        this.$nextTick(() => {
          let protoObj =
            that.winPos[that.cacheList.length + that.cachePointList.length + 1];
          let predictObj =
            that.winPos[that.cacheList.length + that.cachePointList.length + 2];
          $(".DustTip").css("left", protoObj[0]).css("bottom", protoObj[3]);
          $(".dustRotate")
            .css("transform", "scale(1)")
            .css("left", "0px")
            .css("bottom", "0px")
            .css("textIndent", 0)
            .show();
          $(".DustTip").show();
          let deltaX = predictObj[0] - protoObj[0];
          let deltaY = predictObj[3] - protoObj[3];
          let xyRate = deltaX / deltaY;

          $(".dustRotate")
            .attr("leftVal", deltaX)
            .attr("bottomVal", deltaY)
            .delay(3000)
            .animate(
              { textIndent: 600 }, //textIndent的值便是now的終值
              {
                step: function (now, fx) {
                  let deltaX = parseInt($(this).attr("leftVal"));
                  let deltaY = parseInt($(this).attr("bottomVal"));
                  $(this)
                    .css(
                      "transform",
                      "scale(" +
                        (1 +
                          Math.abs(Math.abs(300 - (now < 400 ? now : 400)) - 300) / 30) +
                        ")"
                    )
                    .css("transformOrigin", "center center")
                    .css("left", (deltaX * (now < 400 ? now : 400)) / 400)
                    .css("bottom", (deltaY * (now < 400 ? now : 400)) / 400);
                },
                duration: 20000,
              },
              "linear"
            );
          /*$(".DustTip")
            .delay(5000)
            .animate({ left: deltaX + "px", bottom: deltaY + "px" }, 5000);*/
        });

        //debugger;
      }
      /*if ($(".DustTip").length > 0) {
        $(".DustTip").show();
        $(".DustTip").css("transform", "scale(" + (1 + (curRate / frequency) * 6) + ")");
      }
      curRate++;
      if (curRate < frequency) {
        if (this.dustTimer) {
          clearTimeout(this.dustTimer);
        }
        this.dustTimer = setTimeout(() => {
          that.getDustPos(earth, height, lng, lat, lng_, lat_, curRate);
        }, 50);
      }*/
    },
    //画弹窗
    async drawTip(tipID, lng, lat, height, n, earth, infoObj) {
      let that = this;
      if (that.$isStop.status || that.stopIndex === n) {
        return;
      }

      let pin = earth.sceneTree.$refs[tipID];

      let tmpNode = $("#" + tipID);
      tmpNode.fadeOut(0);
      //去掉随机状态
      // that.cacheList[n]["type"] = Math.floor(Math.random() * 4);

      //靠近飞越
      try {
        let flyArg = JSON.parse(g_bme3dManager.earth.camera.toAllJSONStr());

        const earth = window.g_bme3dManager.earth;

        if (that.$dutyTimer[n]["flyleave"]) {
          clearTimeout(that.$dutyTimer[n]["flyleave"]);
        }
        that.$dutyTimer[n]["flyleave"] = setTimeout(function () {
          if (that.$isStop.status || that.stopIndex === n) {
            return;
          }
          let flyObj = earth.camera.flyTo(
            [(lng * Math.PI) / 180.0, (lat * Math.PI) / 180.0, that.altitude + 50],
            that.flyAltitude +
              (bmeConfig.nearByDistance ? bmeConfig.nearByDistance : 350),
            flyArg.rotation,
            that.needDetail ? 1 : 1.4
          );
        }, 50);
      } catch (err) {
        console.log(err);
      }

      if (this.$dutyTimer[n]["renderData"]) {
        clearTimeout(this.$dutyTimer[n]["renderData"]);
      }
      this.$dutyTimer[n]["renderData"] = setTimeout(
        function () {
          if (that.$isStop.status || that.stopIndex === n) {
            return;
          }
          let pinCzm;
          if (pin) {
            let pos =
              "[" + lng + "*Math.PI/180.0, " + lat + "*Math.PI/180.0," + height + "]";
            let pos1 = eval(pos);
            pinCzm = pin.czmObject;
            pinCzm.position = pos1;
            XE.MVVM.track(that, "winPos." + n, pinCzm, "winPos");
          } else {
            let pos =
              "[" + lng + "*Math.PI/180.0, " + lat + "*Math.PI/180.0," + height + "]";
            let pos1 = eval(pos);
            var tipListObj = {
              ref: tipID,
              czmObject: {
                name: tipID,
                xbsjType: "Pin",
                position: pos1,
                near: 300,
                show: false,
              },
            };
            earth.sceneTree.root.children.push(tipListObj);
            pinCzm = earth.sceneTree.$refs[tipID].czmObject;
            XE.MVVM.track(that, "winPos." + n, pinCzm, "winPos");
          }

          that.$forceUpdate();
          that.$nextTick(function () {
            let tmpNode = $("#" + tipID);
            let compontentBar = tmpNode.find(".warn_block").find(".popupBar");
            //tmpNode.fadeOut(0);
            let isLeft = false,
              isTop = false;

            let ltPos = that.getOffsetTLByBody(tmpNode.get(0));
            let innerPos = that.getOffsetTLByBody(compontentBar.get(0));
            let l = pinCzm._winPos[0] / this.prew;
            let b = pinCzm._winPos[3] / this.prew;

            let screenW = $(".components_container").outerWidth();
            let screenH = $(".components_container").outerHeight();
            tmpNode.removeClass("bottomLeft");
            tmpNode.removeClass("bottomRight");

            //if (l > screenW / 2) {
            if (that.countIndex % 2 === 0) {
              that.countIndex++;
              //if (that.countIndex % 2 === 0) {
              //tmpNode.find(".warn_innerBlock").css("left", -tmpNode.outerWidth());
              //tmpNode.find(".warn_innerBlock").css("left", screenW * 0.2);
              tmpNode.find(".warn_innerBlock").css("transformOrigin", "left bottom");
              tmpNode
                .find(".warn_innerBlock")
                .css("left", l - 30)
                .css("bottom", b);
              tmpNode
                .find(".warn_innerBlock")
                .css("transform", "scale(0.1, 0.1) translate(0px, 0px) rotateY(90deg)");

              isLeft = false;
            } else {
              that.countIndex++;
              //tmpNode.find(".warn_innerBlock").css("left", tmpNode.outerWidth());
              /*tmpNode
            .find(".warn_innerBlock")
            .css("left", screenW * 0.8 - tmpNode.outerWidth());*/
              //tmpNode.find(".warn_innerBlock").css("left", l).css("bottom", b);
              tmpNode.find(".warn_innerBlock").css("transformOrigin", "left bottom");
              tmpNode
                .find(".warn_innerBlock")
                .css("left", l - 30)
                .css("bottom", b);
              tmpNode
                .find(".warn_innerBlock")
                .css("transform", "scale(0.1, 0.1) translate(0px, 0px) rotateY(-90deg)");

              isLeft = true;
            }

            tmpNode.fadeOut(0);

            /*if (this.$dutyTimer[n]["fadeIn"]) {
          clearTimeout(this.$dutyTimer[n]["fadeIn"]);
          if (this.$dutyTimer[n]["fadeOut"]) {
            clearTimeout(this.$dutyTimer[n]["fadeOut"]);
            this.$isStop.status = false;
          }
        }*/

            if (this.$dutyTimer[n]["fadeIn"]) {
              clearTimeout(this.$dutyTimer[n]["fadeIn"]);
            }
            this.$dutyTimer[n]["fadeIn"] = setTimeout(function () {
              tmpNode.fadeIn(2000, function () {
                if (that.$isStop.status || that.stopIndex === n) {
                  return;
                }

                if (that.$dutyTimer[n]["fadeOut"]) {
                  clearTimeout(that.$dutyTimer[n]["fadeOut"]);
                }
                that.$dutyTimer[n]["fadeOut"] = setTimeout(function () {
                  if (that.$isStop.status || that.stopIndex === n) {
                    return;
                  }
                  //镜头移近
                  if (that.needDetail) {
                    if (that.$dutyTimer[n]["fadeOut"]) {
                      clearTimeout(that.$dutyTimer[n]["fadeOut"]);
                    }
                    that.$dutyTimer[n]["fadeOut"] = setTimeout(function () {
                      that.cacheList[n]["status"] = "wait";
                      if (that.$isStop.status || that.stopIndex === n) {
                        return;
                      }

                      that.renderPoint(lng, lat, earth, that.cacheList[n]["type"]);
                      try {
                        let flyArg = JSON.parse(
                          g_bme3dManager.earth.camera.toAllJSONStr()
                        );

                        const earth = window.g_bme3dManager.earth;

                        if (that.$dutyTimer[n]["flyleave"]) {
                          clearTimeout(that.$dutyTimer[n]["flyleave"]);
                        }
                        that.$dutyTimer[n]["flyleave"] = setTimeout(function () {
                          if (that.$isStop.status || that.stopIndex === n) {
                            return;
                          }
                          let flyObj = earth.camera.flyTo(
                            [
                              (lng * Math.PI) / 180.0,
                              (lat * Math.PI) / 180.0,
                              that.altitude + 50,
                            ],
                            that.flyAltitude + 2500,
                            flyArg.rotation,
                            1.4
                          );
                        }, 50);

                        if (that.$dutyTimer[n]["flyTo"]) {
                          clearTimeout(that.$dutyTimer[n]["flyTo"]);
                        }
                        that.$dutyTimer[n]["flyTo"] = setTimeout(function () {
                          if (that.$isStop.status || that.stopIndex === n) {
                            return;
                          }
                          earth.camera.flyTo(
                            [
                              (lng * Math.PI) / 180.0,
                              (lat * Math.PI) / 180.0,
                              that.altitude + 50,
                            ],
                            /*that.flyAltitude + 350,*/
                            that.flyAltitude +
                              (bmeConfig.nearByDistance ? bmeConfig.nearByDistance : 350),
                            flyArg.rotation,
                            1.4
                          );
                          let screenW = $(".components_container").outerWidth();
                          let screenH = $(".components_container").outerHeight();
                          $(that.$refs.infoDetail).fadeOut(0);
                          $(that.$refs.infoDetail).css("top", screenH / 2 - 410 + "px");
                          $(that.$refs.infoDetail).css(
                            "left",
                            screenW / 2 - 430 / 2 + "px"
                          );
                          $(that.$refs.infoDetail)
                            .find(".warn1-Tiny")
                            .removeClass("warn1-large");
                          $(that.$refs.infoHistory).fadeOut(0);
                          $(that.$refs.infoHistory).css(
                            "top",
                            screenH / 2 - 410 + 500 + "px"
                          );
                          $(that.$refs.infoHistory).css("left", screenW / 2 + 100 + "px");
                          $(that.$refs.infoHistory).removeClass("infoHistory-large");
                          if (that.$dutyTimer[n]["detailIn"]) {
                            clearTimeout(that.$dutyTimer[n]["detailIn"]);
                          }
                          that.$dutyTimer[n]["detailIn"] = setTimeout(function () {
                            if (that.$isStop.status || that.stopIndex === n) {
                              return;
                            }
                            $(that.$refs.infoHistory).fadeIn(1400);
                            $(that.$refs.infoDetail).fadeIn(1400);

                            if (that.$dutyTimer[n]["detailTransform"]) {
                              clearTimeout(that.$dutyTimer[n]["detailTransform"]);
                            }
                            that.$dutyTimer[n]["detailTransform"] = setTimeout(
                              function () {
                                if (that.$isStop.status || that.stopIndex === n) {
                                  return;
                                }
                                $(that.$refs.infoDetail)
                                  .find(".warn1-Tiny")
                                  .addClass("warn1-large");
                                $(that.$refs.infoHistory).addClass("infoHistory-large");

                                if (that.$dutyTimer[n]["detailOut"]) {
                                  clearTimeout(that.$dutyTimer[n]["detailOut"]);
                                }
                                that.$dutyTimer[n]["detailOut"] = setTimeout(function () {
                                  if (that.$isStop.status || that.stopIndex === n) {
                                    return;
                                  }
                                  $(that.$refs.infoDetail).fadeOut(1000);
                                  $(that.$refs.infoHistory).fadeOut(1000);

                                  if (that.$dutyTimer[n]["rerender"]) {
                                    clearTimeout(that.$dutyTimer[n]["rerender"]);
                                  }
                                  that.$dutyTimer[n]["rerender"] = setTimeout(
                                    function () {
                                      if (that.$isStop.status || that.stopIndex === n) {
                                        return;
                                      }
                                      //详情之后的结束
                                      that.renderPlay();
                                    },
                                    3000
                                  );
                                }, 5500);
                              },
                              1000
                            );
                            that.detailData = infoObj.data;
                            if (that.detailData) {
                              if (
                                that.detailData.handleState == 0 ||
                                that.detailData.handleState == 1
                              ) {
                                that.treatType = false;
                              } else if (that.detailData.handleState == 2) {
                                that.treatType = false;
                              } else if (that.detailData.handleState == 3) {
                                that.treatType = true;
                              } else {
                                that.treatType = false;
                              }
                            }
                            that.detailID = infoObj.typeId;
                            that.valueHistory = infoObj.data.valueHistory;
                            that.getRealityData();
                          }, 50);
                        }, 3500);
                      } catch (err) {
                        console.log(err);
                      }
                    }, 50);
                  } else {
                    //正常结束
                    tmpNode.fadeOut(2000, function () {
                      that.cacheList[n]["status"] = "wait";
                      if (that.$isStop.status || that.stopIndex === n) {
                        return;
                      }

                      that.renderPoint(lng, lat, earth, that.cacheList[n]["type"]);

                      if (that.$dutyTimer[n]["rerender"]) {
                        clearTimeout(that.$dutyTimer[n]["rerender"]);
                      }
                      that.$dutyTimer[n]["rerender"] = setTimeout(function () {
                        if (that.$isStop.status || that.stopIndex === n) {
                          return;
                        }
                        that.renderPlay();
                      }, 3000);

                      //that.$isStop.status = false;
                    });
                  }
                }, 12000);
              });
              tmpNode
                .find(".warn_innerBlock")
                .addClass(
                  isLeft
                    ? isTop
                      ? "topLeft"
                      : "bottomLeft"
                    : isTop
                    ? "topRight"
                    : "bottomRight"
                );

              //debugger;
              if (isLeft) {
                tmpNode
                  .find(".warn_innerBlock")
                  .css(
                    "transform",
                    "scale(1, 1) translate(" +
                      (bmeConfig.DIY_W * 2 + 100 - l) +
                      "px, " +
                      (b - screenH + 750 + 300) +
                      "px) rotateY(-360deg)"
                  );
              } else {
                tmpNode
                  .find(".warn_innerBlock")
                  .css(
                    "transform",
                    "scale(1, 1) translate(" +
                      (screenW - bmeConfig.DIY_W * 2 - l - 500) +
                      "px, " +
                      (b - screenH + 750 + 300) +
                      "px) rotateY(360deg)"
                  );
              }
            }, 50 + 500);
          });
        },
        that.needDetail ? 1500 : 4000
      );
    },
    getRealityData() {
      let _this = this;
      let valueHistory = this.valueHistory;
      if (valueHistory && valueHistory.length > 0 && valueHistory[0]["dps"]) {
        let dps = valueHistory[0]["dps"];
        this.pmData = {
          xData: [],
          y1Data: [],
          y2Data: [],
        };
        for (let i in dps) {
          this.noData = false;
          this.pmData.xData.push(this.$moment(i * 1000).format("MM-DD hh:mm"));
          this.pmData.y1Data.push(dps[i] ? parseFloat(dps[i].toFixed(2)) : null);
          this.pmData.y2Data.push(0);
        }
        this.$nextTick(() => {
          if (!this.chart) {
            this.chart = echarts.init(this.$refs.chart);
          }
          let optionStr = getOpt(this.pmData, this.detailData.signalName);
          unwarp(this.chart).setOption(optionStr);
        });
      }
    },
    getOffsetTLByBody(el) {
      let offsetTop = 0,
        offsetLeft = 0;
      while (el && el.tagName !== "BODY") {
        offsetTop += el.offsetTop;
        offsetLeft += el.offsetLeft;
        el = el.offsetParent;
      }
      return {
        left: offsetLeft,
        top: offsetTop,
      };
    },
    renderPoint(lng, lat, earth, warnType) {
      let that = this;
      let checkPointIndex = that.checkCachePointAvailable();
      if (checkPointIndex >= 0) {
        let cachePointObj = that.cachePointList[checkPointIndex];
        cachePointObj["lng"] = lng;
        cachePointObj["lat"] = lat;
        cachePointObj["status"] = "play";
        cachePointObj["renderTime"] = new Date().getTime();
        //$("#" + cacheObj["tipID"]).hide();
        that.drawPointTip(
          cachePointObj["tipID"],
          cachePointObj["lng"],
          cachePointObj["lat"],
          bmeConfig.altitude,
          checkPointIndex,
          earth,
          warnType
        );
      } else {
        this.cachePointList = this.cachePointList.sort(function (a, b) {
          return a["renderTime"] - b["renderTime"];
        });
        let cachePointObj = that.cachePointList[0];
        cachePointObj["lng"] = lng;
        cachePointObj["lat"] = lat;
        cachePointObj["status"] = "play";
        //$("#" + cacheObj["tipID"]).hide();
        that.drawPointTip(
          cachePointObj["tipID"],
          cachePointObj["lng"],
          cachePointObj["lat"],
          bmeConfig.altitude,
          0,
          earth,
          warnType
        );
      }
    },
    renderPlay(isDetail) {
      if (this.$isStop.status) {
        return;
      }
      this.lastRenderPlayTime = new Date().getTime();
      this.timeoutClear();
      if (this.playList.length === 0) {
        this.getData();
        return;
      }
      let that = this;
      that.counter++;

      /*if (that.counter % 4 === 0) {
        that.needDetail = true;
      } else {
        that.needDetail = false;
      }*/

      if (isDetail) {
        that.needDetail = true;
      } else {
        that.needDetail = false;
      }

      let checkIndex = that.checkCacheAvailable();
      let lng, lat;
      for (let i = 0; i < that.cacheList.length; i++) {
        if (that.cacheList[i]["tipID"]) {
          let tmpNode = $("#" + that.cacheList[i]["tipID"]);
          if (tmpNode.length > 0) {
            tmpNode.fadeOut(0);
          }
        }
      }
      $(this.$refs.infoDetail).fadeOut(0);
      $(this.$refs.infoHistory).fadeOut(0);
      if (
        that.playList.length > 0 &&
        window.g_bme3dManager &&
        window.g_bme3dManager.earth &&
        !this.$isStop.status
      ) {
        if (checkIndex >= 0) {
          if (that.$isStop.status || that.stopIndex === checkIndex) {
            return;
          }
          if (that.playList.length > 0) {
            that.warnIdx = 0;
            let obj = that.playList.shift();
            let cacheObj = that.cacheList[checkIndex];
            if (!$.isEmptyObject(cacheObj)) {
              lng = obj["lng"];
              lat = obj["lat"];
              cacheObj["lng"] = obj["lng"];
              cacheObj["lat"] = obj["lat"];
              cacheObj["status"] = "play";
              cacheObj["data"] = obj["data"];
              cacheObj["type"] = obj["type"];
              cacheObj["typeId"] = obj["typeId"];
              //cacheObj["workTicketNo"] = obj["workTicketNo"];
              //$("#" + cacheObj["tipID"]).hide();
              that.drawTip(
                cacheObj["tipID"],
                cacheObj["lng"],
                cacheObj["lat"],
                bmeConfig.altitude,
                checkIndex,
                g_bme3dManager.earth,
                obj
              );
            } else {
              that.renderPlay(isDetail);
            }
          } else {
            that.warnIdx = checkIndex;
            let cacheObj = that.cacheList[checkIndex];
            if (!$.isEmptyObject(cacheObj)) {
              lng = cacheObj["lng"];
              lat = cacheObj["lat"];
              that.drawTip(
                cacheObj["tipID"],
                cacheObj["lng"],
                cacheObj["lat"],
                bmeConfig.altitude,
                checkIndex,
                g_bme3dManager.earth,
                obj
              );
            } else {
              that.renderPlay(isDetail);
            }
          }

          let allAvailible = true;
          that.cacheList.forEach((obj, n) => {
            if (obj.status != "wait") {
              allAvailible = false;
            }
          });
          let curTime = new Date().getTime();
          //停止大于10秒钟并且所有
          // console.log(
          //   "停止大于10秒钟并且所有",
          //   curTime - this.stopTime,
          //   allAvailible
          // );
          if (curTime - that.stopTime > 6000 && allAvailible) {
            that.$isStop.status = false;
          }

          /*let deltaTime = that.needDetail ? 20 : 8; //parseInt(Math.random() * 3 + 5);
          if (that.$dutyTimer[checkIndex] && that.$dutyTimer[checkIndex]["renderTimer"]) {
            clearTimeout(that.$dutyTimer[checkIndex]["renderTimer"]);
          } else {
            deltaTime = 3;
          }

          if (checkIndex > 0) {
            that.$dutyTimer[checkIndex]["renderTimer"] = setTimeout(function () {
              if (window.g_bme3dManager && window.g_bme3dManager.earth) {
                const earth = window.g_bme3dManager.earth;
                let view =
                  mapViews[`mapViews_${that.customerId}`] &&
                  mapViews[`mapViews_${that.customerId}`].dutyMod;
                if (view && view.length) {
                  earth.camera.flyTo(view[0], view[1], view[2], 0.5);
                }
              }
            }, 1000);
          } else {
            if (window.g_bme3dManager && window.g_bme3dManager.earth) {
              const earth = window.g_bme3dManager.earth;
              let view =
                mapViews[`mapViews_${that.customerId}`] &&
                mapViews[`mapViews_${that.customerId}`].dutyMod;
              if (view && view.length) {
                earth.camera.flyTo(view[0], view[1], view[2], 0.5);
              }
            }
          }*/
        } else {
          /*if (that.$dutyTimer[checkIndex] && that.$dutyTimer[checkIndex]["renderTimer"]) {
            clearTimeout(that.$dutyTimer[checkIndex]["renderTimer"]);
          }
          if (checkIndex < 0) {
            that.renderPlay();
          } else {
            that.$dutyTimer[checkIndex]["renderTimer"] = setTimeout(function () {
              that.renderPlay();
            }, 1000);
          }*/
          that.timeoutClear();
          if (that.restoreWarnTimer) {
            clearTimeout(that.restoreWarnTimer);
          }
          that.restoreWarnTimer = setTimeout(function () {
            that.renderPlay();
          }, 1000);
        }
      } else {
        /*if (that.$dutyTimer[checkIndex] && that.$dutyTimer[checkIndex]["renderTimer"]) {
          clearTimeout(that.$dutyTimer[checkIndex]["renderTimer"]);
        }
        if (checkIndex < 0) {
          that.renderPlay();
        } else {
          that.$dutyTimer[checkIndex]["renderTimer"] = setTimeout(function () {
            that.renderPlay();
          }, 1000);
        }*/
        that.timeoutClear();
        if (that.restoreWarnTimer) {
          clearTimeout(that.restoreWarnTimer);
        }
        that.restoreWarnTimer = setTimeout(function () {
          that.renderPlay();
        }, 1000);
      }
    },
    async getFindSpread(deviceNo) {
      //https://vis.bmetech.com/vis/homePage/findSpread?deviceNo=BMEPMLED18090508
      let getFindSpreadUrl = CONFIG.requestName + this.$apiOpt.findSpread;
      let data = await this.$apiUtils.get(getFindSpreadUrl, {
        deviceNo: deviceNo,
      });
      return data;
    },
    async getDevicePos(deviceNo) {
      let getDevice = CONFIG.requestName + this.$apiOpt.getDevice;
      let data = await this.$apiUtils.get(getDevice, {
        deviceNo: deviceNo,
      });
      let devicePos = {};
      if (data) {
        devicePos = {
          longitude: data.longitude || 0,
          latitude: data.latitude || 0,
        };
      } else {
        devicePos = {
          longitude: 0,
          latitude: 0,
        };
      }
      return devicePos;
    },
    checkCachePointAvailable() {
      let num = -1;
      try {
        this.cachePointList.forEach((obj, n) => {
          if (obj.status == "wait") {
            num = n;
            throw Error("有空闲");
          }
        });
      } catch (err) {
        console.log("有空闲");
      }
      return num;
    },
    checkCacheAvailable() {
      let num = -1;
      try {
        this.cacheList.forEach((obj, n) => {
          if (obj.status == "wait") {
            num = n;
            throw Error("有空闲");
          }
        });
      } catch (err) {
        console.log("有空闲");
      }
      return num;
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
.warn1_title {
  display: flex;
  align-items: flex-end;
  border-bottom: 1px solid;
  border-image: linear-gradient(-90deg, #4fa7ff, #88f7ff) 1 1;
  justify-content: space-between;
  .popup-type1-title {
    height: 30px;
    font-size: 22px;
    font-weight: 500;
    color: #ff7373;
    line-height: 30px;
    display: flex;
    align-items: center;
    &::before {
      content: "";
      display: block;
      width: 7px;
      height: 7px;
      background: #ff7373;
      box-shadow: 0px 0px 7px 0px #df3131;
      border: 1px solid #da3636;
      border-radius: 50%;
      display: inline-block;
      margin-right: 16px;
    }
  }
  .popup-type1-time {
    // height: 14px;
    padding-bottom: 5px;
    font-size: 14px;
    color: #ffffff;
    line-height: 14px;
  }
}
.infoDetail {
  position: fixed;
  //top: 120px;
  //left: calc(50% - 215px);
  z-index: 998;
  display: none;
}

.infoHistory {
  position: fixed;
  //top: calc(50% + 200px);
  //left: calc(50% + 100px);
  z-index: 998;
  display: none;
  width: 500px;
  height: 220px;
  padding: 10px 30px 35px 30px;
  background: linear-gradient(45deg, rgba(0, 0, 0.8), rgba(0, 0, 0, 0.3));
  border-radius: 15px;
  transform-origin: top left;
  transform: scale(0.01);
}

.infoHistory-large {
  transform: scale(1) !important;
  transition: all 0.75s linear 0.25s;
}

.historyChart {
  position: relative;
  width: 100%;
  height: 100%;
}

.warn1-Tiny {
  transform: scale(0.01);
  transform-origin: bottom center;
}

.warn1-large {
  transform: scale(1) !important;
  transition: all 0.75s linear 0s;
}

.warn_innerBlock {
  position: fixed;
  transition: all 0.5s linear 0s;
  width: 450px;
  height: 732px;
}

.warn_block {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 100%;
}
.md-modal {
  z-index: 10001;
}
.md-content {
  padding: 75px 100px;
  background: rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 10px 5px #ccc;
}
.pointerEventAll {
  pointer-events: all;
}
.test {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  //pointer-events: auto;
  overflow: hidden;
  .processComponent {
    .everyComponent {
      ul {
        width: 100%;
        height: 100%;
        pointer-events: auto;
        .ComponentTip_ {
          background-size: 100% 100%;
          width: 46px;
          height: 46px;
          position: absolute;
          pointer-events: auto;
          img {
            animation: twinkle 1.5s;
            animation-iteration-count: infinite;
            // transform-origin: top center;
            animation-timing-function: linear;
          }
          .green {
            width: 100%;
            position: absolute;
            bottom: 0px;
            position: absolute;
          }
          .red {
            width: 100%;
            position: absolute;
            bottom: 0px;
            position: absolute;
          }
        }
        .DustTip {
          background-size: 100% 100%;
          //background: red;
          width: 50px;
          height: 50px;
          position: absolute;
          display: none;
          img {
            position: absolute;
            width: 50px;
            height: 50px;
          }
        }
        .ComponentTip {
          // background:  url('./img/1.png') no-repeat;
          background-size: 100% 100%;
          //background: red;
          width: 500px;
          height: 320px;
          position: absolute;
          display: none;
          // pointer-events: auto;

          div {
            .img-title {
              width: 100%;
              position: absolute;
              bottom: 150px;
              z-index: 1;
              background: url(./img/xk.png) no-repeat left top;
              background: url(./img/sk.png) no-repeat left bottom;
            }
            .img2 {
              width: 100%;
              animation: circleScale 1.5s;
              animation-iteration-count: infinite;
              transform-origin: top center;
              animation-timing-function: linear;
              position: absolute;
              bottom: -400px;
              //left: 25%;
            }
            .img-Image {
              width: 100%;
              position: absolute;
              bottom: 100px;
            }
            .img-video {
              width: 100%;
              position: absolute;
              bottom: 100px;
            }
            .warn1 {
              width: 100%;
              position: absolute;
              bottom: 100px;
            }
            .warn2 {
              width: 100%;
              position: absolute;
              bottom: 750px;
            }
            .warn3 {
              width: 100%;
              position: absolute;
              bottom: 700px;
            }
            .green {
              width: 100%;
              transform: scale(0.1);
              position: absolute;
              bottom: -120px;
            }
            .red {
              width: 100%;
              transform: scale(0.1);
              position: absolute;
              bottom: -120px;
            }
          }
        }
      }
    }
  }
}
@keyframes circleScale {
  0% {
    transform: rotateX(105deg) scale(0.1);
  }
  // 50% {
  //   transform: translateY(110px) rotateX(105deg) scale(0.75);
  // }
  100% {
    transform: rotateX(105deg) scale(0.3);
  }
}

@keyframes twinkle {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.dustRotate {
  display: none;
}

#mvideo {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
}
.ddd {
  width: 46px;
  height: 46px;
  background-color: skyblue;
  position: absolute;
}

.topLeft {
  transform-origin: top left;
  -webkit-transform-origin: top left;
}

.topRight {
  transform-origin: top right;
  -webkit-transform-origin: top right;
}

.bottomLeft {
  transform-origin: bottom left;
  -webkit-transform-origin: bottom left;
  //left: 750px !important;
  //bottom: 50px !important;
  //transform: scale(1, 1) translate(750px, 100px) !important;
  transition: all 1.2s;
  transition-delay: 0.8s;
  transition-timing-function: ease-in-out;
}

.bottomRight {
  transform-origin: bottom right;
  -webkit-transform-origin: bottom right;
  //left: calc(100% - 1150px) !important;
  //bottom: 50px !important;
  //transform: scale(1, 1) translate(calc(100% - 1150px), 100px) !important;
  transition: all 1.2s;
  transition-delay: 0.8s;
  transition-timing-function: ease-in-out;
}
</style>
